import React from 'react'
import PropTypes from 'prop-types'
import Button from '../../ui/Button'

const FilterFooter = ({
  isSubmitting = false,
  isClearing = false,
  onClearFilters,
  onApplyFilters,
  disabled
}) => (
  <div className="border-top p-3 d-flex justify-content-end tw:gap-2">
    <Button
      variant="neutral"
      icon="trash"
      disabled={isClearing || isSubmitting}
      onClick={onClearFilters}
    >
      {isClearing ? 'Chargement...' : 'Effacer les filtres'}
    </Button>
    <Button
      className="tw:ml-2"
      disabled={disabled || isClearing}
      onClick={onApplyFilters}
    >
      {isSubmitting ? 'Chargement...' : 'Afficher les résultats'}
    </Button>
  </div>
)

FilterFooter.propTypes = {
  disabled: PropTypes.bool.isRequired,
  isClearing: PropTypes.bool,
  isSubmitting: PropTypes.bool,
  onApplyFilters: PropTypes.func.isRequired,
  onClearFilters: PropTypes.func.isRequired
}

FilterFooter.defaultProps = {
  isClearing: false,
  isSubmitting: false
}

export default FilterFooter
